module.exports = __webpack_public_path__ + "img/Imagecewek.8b7f9937.png";